<template>
    <!-- 客户收款明细 -->
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="交易日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="交易日期"></el-date-picker>
                </div>
                <div class="search_time search_time search_inputBox">
                    <el-input type="text" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.search.course_title" placeholder="状态">
                    <el-option :value="'结算'" :label="'结算'"></el-option>
                    <el-option :value="'进销货款'" :label="'进销货款'"></el-option>
                </el-select>
                <div class="reset fcolor" @click="resetSearch">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="execlInsert clearfix">
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
                <div class="header_row_return" @click="backList">
                   返回列表
                </div>
            </div>
            <!-- <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked">删除</el-button>
            </div> -->
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" @getTableEdit="getTableEdit" @getTableDelete="getTableDelete" :tabledata="list" @getRow="getRow"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">实收总金额： {{totalObj.inout_amount}}</div>
                <div class="totalNumber">结算总金额：{{totalObj.settlement_amount}}</div>
                <div class="totalNumber">客户余额：{{totalObj.customer_balance}}</div>
                <div class="totalNumber"></div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 新增收款单 dialog START -->
        <el-dialog v-dialog-drag title="修改收款单" :visible.sync="addDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="销售单号：">
                        <el-input v-model="add_params.order_sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：">
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户名称：">
                        <el-input v-model="add_params.customer_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" placeholder="" >
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易方式：">
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易RMB金额：">
                        <el-input v-model="add_params.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheet">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增收款单 dialog END -->
        <!-- 结算确认 dialog START -->
        <el-dialog v-dialog-drag title="结算确认" :visible.sync="sureDialogVisible" width="500px" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <!-- <div class="eldialogFormBox">
                    <el-form-item label="客户余额：" class="other_form_item">
                        <div style="text-align:left;">{{bill.balance}}</div>
                    </el-form-item>
                </div> -->
                <div class="eldialogFormBox">
                    <el-form-item label="结算RMB金额：" class="other_form_item">
                        <el-input v-model="sure_params.amount" @input="settlementInput" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" v-model="sure_params.remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="settlement">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="sureDialogVisible = false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<style scoped>
    .execlInsert{right: 80px;top: 10px;}
    .header_row_return{float: right;font-size: 14px;font-weight: 600;}
    .search_box{padding-right:10px;}
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                id:"",
                jumpType:"",
                start_time:"",
                end_time:"",
                params:{
                    search:{
                        start_time: "",
                        end_time:"",
                        order_sn:"",
                        course_title:""
                    },
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                list : [],
                tableCol:[	
                    {colName:"交易日期",colKey:"trading_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"科目名称",colKey:"course_title",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"我方账户",colKey:"account_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付款方式",colKey:"payment_type_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实收金额",colKey:"inout_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"结算金额",colKey:"settlement_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"销售单号",colKey:"order_sn",colWidth:190,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"经办人",colKey:"operator_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                selectRow:[],
                totalObj:{},
                bill:{},
                trading_time:"",
                selectMap:{
                    customer:[],
                    user:[],
                    account:[],
                    paymentType:[],
                    lockLevel:[]
                },
                add_params : {
                    order_id : "",
                    bill_type : "",
                    amount : "",
                    account_id : "",
                    customer_id : "",
                    trading_time :"",
                    trading_mode_id : "",
                    course_title : "进销货款",
                    remark : ""
                },
                addDialogVisible:false,
                sureDialogVisible:false,
                sure_params : {
                    order_id : "",
                    amount : "",
                    remark : ""
                },
                customer_id:"",
                settlement_amount:0
            }
        },
        created(){
            if(sessionStorage.DEMU_ERP_RECEIVABLE_ID){
                this.id=sessionStorage.DEMU_ERP_RECEIVABLE_ID;
                this.jumpType = sessionStorage.DEMU_ERP_PAYSUMMARY_TYPE;
                sessionStorage.removeItem("DEMU_ERP_RECEIVABLE_ID")
                sessionStorage.removeItem("DEMU_ERP_PAYSUMMARY_TYPE")
            }
            this.getSelectList("user")
            this.getSelectList("customer")
            this.getSelectList("account")
            this.getSelectList("paymentType")
            this.getSelectList("lockLevel")
            this.getList();
        },
        methods:{
            excelExport(){
                this.$exportExecl("/erp/finance.bill.customer.export","客户收款明细",this.params)
            },
            getBillMess(id){
                this.postFunc("/erp/customer.detail",{id:id},response=>{
                    this.bill=response.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //结算
            settlement(){
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/finance.bill.update.settlement",this.sure_params,()=>{
                        this.tip("结算成功","success")
                        this.sureDialogVisible=false;
                        this.getBillMess(this.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            settlementInput(val){
                var reg = /(^[1-9][0-9]{0,8}([.][0-9]{0,2})?$)|(^0?(\.[0-9]{0,2})?$)/;
                if(reg.test(val)){
                    this.sure_params.amount = val;
                    this.sure_params_amount = val;
                }else{
                    this.sure_params.amount = this.sure_params_amount;
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            addOrderSheet(){
                this.$confirm('是否确认修改?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if(Number(this.trading_time)){
                        this.add_params.trading_time = parseInt(this.trading_time/1000)
                    }else{
                        this.add_params.trading_time = parseInt(this.trading_time.getTime()/1000)
                    }
                    this.postFuncLoading("/erp/finance.bill.update.inout",this.add_params,()=>{
                        this.tip("修改成功","success")
                        this.addDialogVisible=false;
                        // this.dialogVisible=false;
                        // this.getBillMess(this.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableEdit(id){
                this.list.forEach(item=>{
                    if(item.id == id){
                        this.pl(item)
                        this.customer_id = item.customer_id;
                        if(item.bill_type == 1 || item.bill_type == 0){
                            this.postFunc("/erp/finance.bill.view",{id:id},res=>{
                                this.add_params = res.data.data;
                                this.trading_time = res.data.data.trading_time*1000;
                                this.addDialogVisible = true;
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }else if(item.bill_type == 2){
                            this.sure_params.amount = item.settlement_amount;
                            this.sure_params.id = item.id;
                            this.sureDialogVisible = true;
                        }
                    }
                })
            },
            backList(){
                if(this.jumpType == 1){
                    this.$root.$children[0].$children[0].showTab({
                        label: "应收管理",
                        name: "应收管理",
                        content: "componentsReceivableSummary",
                    });
                }else{
                    this.$root.$children[0].$children[0].showTab({
                        label: "应付管理",
                        name: "应付管理",
                        content: "payReceivable",
                    });
                }
            },
            getTableDelete(id){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/bill.delete",{ids:id},()=>{
                        this.tip("删除成功","success")
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.customer_id=this.id;
                this.params.search.start_time=this.formatTimeZero(this.start_time);
                this.params.search.end_time=this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.postFunc("/erp/finance.bill.customer",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list;
                    this.totalObj=res.data.data.statistics;
                    this.list.forEach((item,index)=>{
                        item.isDelete = !!item.isDelete;
                        item.isEdit = !!item.isEdit;
                        if(item.trading_time!=0){
                            this.list[index].trading_time = this.formatTime(item.trading_time+"000")
                        }
                        if(Number(item.settlement_amount)==0){
                            this.list[index].settlement_amount = "";
                        }else{
                            this.list[index].baseColor = "green";
                        }
                        if(Number(item.inout_amount)==0){
                            this.list[index].inout_amount = "";
                        }else{
                            this.list[index].baseColor = "#FF0000";
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getRow(row){
                this.selectRow=row;
            },
            resetSearch(){
                this.start_time="",
                this.end_time="",
                this.params={search:{start_time: "",end_time:"",order_sn:"",course_title:""},per_page: 50,page:1}
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisible":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params)
                    this.add_params.course_title="进销货款";
                    this.customer_id = "";
                }
            },
            "sureDialogVisible":function(val){
                if(!val){
                    this.sure_params=this.resetJson(this.sure_params)
                    this.customer_id = "";
                }
            },
        }
    }
</script>
